export default __webpack_public_path__ + "static/media/david.8b9a3e20.png";